import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../../../_common/Loader/Loader';
import Table from '../../../../../_common/Tables/Table';
import Button from '../../../../../_common/Form/Buttons/Button';
import TopPhysiciansModal from './TopPhysiciansModal';
import classes from '../../../dashboard.module.scss';
import Api from '../../../../../../api/api';

const PREVIEW_LIMIT = 5;

const RANK_COLORS = ['#F59E0B', '#9CA3AF', '#CD7F32'];

const TABLE_HEADER = [
  {
    name: '#',
    path: 'rank',
    render: (d) => (
      <span style={{
        fontWeight: 700,
        fontSize: 13,
        color: RANK_COLORS[d.rank - 1] ?? '#374151',
      }}
      >
        {d.rank}
      </span>
    ),
  },
  { name: 'Physician', path: 'physician' },
  { name: 'Specialty', path: 'specialty' },
  { name: 'Scripts', path: 'scriptCount' },
  { name: 'Revenue', path: 'revenue', type: 'currency' },
];

const TopPhysiciansTable = ({ requestData }) => {
  const navigate = useNavigate();

  const [topPhysiciansData, setTopPhysiciansData] = useState([]);
  const [loading, loadingToggle] = useState(true);
  const [showAll, showAllToggle] = useState(false);
  const [showModal, modalToggle] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        loadingToggle(true);

        const { data } = await Api.getDashboardTopPhysicians({ ...requestData, page: 1, limit: PREVIEW_LIMIT });

        setTopPhysiciansData((data?.data?.response || []).map((d, i) => ({
          ...d,
          id: d.physicianId,
          rank: i + 1,
          specialty: d.specialty || '-',
        })));

        showAllToggle((data?.data?._meta?.total || 0) > PREVIEW_LIMIT);
        loadingToggle(false);
      } catch (e) {
        console.warn(e);
      }
    })();
  }, [requestData]);

  return (
    <div
      className={classes.chart_kpi_wrapper}
      style={{
        background: '#fff',
        borderRadius: 12,
        padding: 16,
        width: '100%',
        minHeight: 288,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <p style={{
        margin: '0 0 12px',
        fontWeight: 700,
        fontSize: 15,
        color: '#111827',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
      >
        Top physicians by revenue

        {!loading && showAll && (
          <Button
            title="View all"
            onClick={() => modalToggle(true)}
            className={classes.view_all}
          />
        )}
      </p>

      {loading
        ? <Loader className={classes.chart_kpi_wrapper_loader} />

        : (
          <Table
            data={topPhysiciansData}
            header={TABLE_HEADER}
            className={classes.clickable_row}
            onClick={(physicianId) => navigate(`/physicians/${physicianId}`)}
          />
        )}

      <TopPhysiciansModal
        isOpen={showModal}
        requestData={requestData}
        tableHeader={TABLE_HEADER}
        onClose={() => modalToggle(false)}
      />
    </div>
  );
};

export default TopPhysiciansTable;
